module.exports = __webpack_public_path__ + "img/next.fb6c7a7b.svg";